/**
 * Legacy FLUX constants, please don't add new variables to this file.
 *
 * @deprecated
 */
export const {MESSAGES, PROFILE} = {
	MESSAGES: {
		LOAD: 'MESSAGES_LOAD',
		APPEND_MESSAGE: 'MESSAGES_APPEND',
	},
	PROFILE: {
		LOAD: 'PROFILE_LOAD',
		PICTURE: {
			LOAD: 'PROFILE_PICTURE_LOAD',
		},
	},
};
